"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _resizeObserverPolyfill = _interopRequireDefault(require("resize-observer-polyfill"));

var _throttle3 = _interopRequireDefault(require("../../utils/throttle"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useSize = function useSize() {
  var _useState = (0, _react.useState)({
    height: 0,
    width: 0
  }),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      size = _useState2[0],
      setSize = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      element = _useState4[0],
      setElement = _useState4[1];

  (0, _react.useEffect)(function () {
    if (!element) {
      return;
    }

    var _throttle = (0, _throttle3["default"])(function () {
      return setSize({
        height: element.offsetHeight,
        width: element.offsetWidth
      });
    }),
        _throttle2 = (0, _slicedToArray2["default"])(_throttle, 2),
        handleResize = _throttle2[0],
        cancelThrottle = _throttle2[1];

    handleResize();
    window.addEventListener('resize', handleResize);
    var elementObserver = new _resizeObserverPolyfill["default"](handleResize);
    elementObserver.observe(element);
    return function () {
      window.removeEventListener('resize', handleResize);
      elementObserver.disconnect();
      cancelThrottle();
    };
  }, [element]);
  return _objectSpread(_objectSpread({}, size), {}, {
    ref: setElement
  });
};

var _default = useSize;
exports["default"] = _default;